export var getOverflowParents = function (element) {
    var parents = [];
    var node = element;
    while ((node = node.parentElement) && node !== document.body) {
        getComputedStyle(node).overflow !== 'visible' && parents.push(node);
    }
    return parents;
};
export var getOverflowParentDimensions = function (element, excludeClosestParent, expandToViewport) {
    if (excludeClosestParent === void 0) { excludeClosestParent = false; }
    if (expandToViewport === void 0) { expandToViewport = false; }
    var parents = expandToViewport
        ? []
        : getOverflowParents(element).map(function (el) {
            var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
            return {
                height: height,
                width: width,
                top: top,
                left: left
            };
        });
    parents.push({
        height: window.innerHeight,
        width: window.innerWidth,
        top: 0,
        left: 0
    });
    if (excludeClosestParent && !expandToViewport) {
        parents.shift();
    }
    return parents;
};
var _cachedBrowserScrollbarSize;
export function browserScrollbarSize() {
    if (typeof _cachedBrowserScrollbarSize !== 'undefined') {
        return _cachedBrowserScrollbarSize;
    }
    if (typeof document === 'undefined') {
        return { width: 0, height: 0 };
    }
    var scrollDiv = document.createElement('div');
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.height = '100px';
    scrollDiv.style.width = '100px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.left = '-9999px';
    document.body.appendChild(scrollDiv);
    var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    var height = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    _cachedBrowserScrollbarSize = { width: width, height: height };
    return _cachedBrowserScrollbarSize;
}
/**
 * If the element is out of view, scrolls the scroll parent until
 * the element is visible.
 *
 * Basically an IE11/Safari polyfill for `elem.scrollIntoView({ block: 'nearest' })`
 */
export function scrollUntilVisible(element) {
    var _a;
    var parent = (_a = element.offsetParent) !== null && _a !== void 0 ? _a : document.documentElement;
    // Anchor to top of scroll parent.
    if (element.offsetTop < parent.scrollTop) {
        parent.scrollTop = element.offsetTop;
    }
    // Anchor to bottom of scroll parent.
    if (element.offsetTop + element.clientHeight > parent.scrollTop + parent.clientHeight) {
        parent.scrollTop = element.offsetTop + element.clientHeight - parent.clientHeight;
    }
}
//# sourceMappingURL=scrollable-containers.js.map